<action class="wishlist-button flex flex-middle flex-justify-center cursor-pointer"
        [status]="status"
        (click)="remove()"
        aria-label="Remove from Wishlist">
    <i class="flex icon-close"
       [style.font-size.em]="1"
       aria-hidden="true"></i>
</action>
<result class="block pos-absolute top-100"
        [status]="status"></result>